import React, { Component } from 'react';
import ContainerDivided from 'screens/components/basic/ContainerDivided';
import LOOKUP from 'constants/lookup';
import { Link } from 'react-router-dom';
import env from 'config/env';

export default class ReportWraper extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            reportName: this.props.reportName || ''
        };
    }

    render() {
        return (
            <ContainerDivided>
                <div className="row d-flex justify-content-center">
                    <iframe src={`${env.reportsAPIUrl()}${this.state.reportName}?&rc:Zoom=100&rs:embed=true`} width="100%" height="720"> </iframe>
                </div>
            </ContainerDivided>
        );
    }
}